import { Paper, Typography } from '@mui/material'

export default function SelectItemHint({ type }: { type: 'event' | 'course' }) {
  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        bgcolor: 'background.paperDark',
      }}
    >
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 500 }}>
        Select a{type === 'event' ? 'n Event' : ' Course'} to View Details
      </Typography>
      <Typography color="text.secondary" variant="body1">
        Choose a {type} from the list to view and edit its planning details,
        syllabus, accreditation, and assessment information.
      </Typography>
    </Paper>
  )
}
